import React from 'react';
import Type from './Type';
import Name from './Name';
import Images from './Images';
import Size from './Size';
import Parts from './Parts';
import Finishes from './Finishes';
import Notes from './Notes';
import {
  setCurrentRequestFilesSize,
  setCurrentRequestPageId,
  setCurrentRequestSubPageId,
  updateRequestPages,
} from '../../../redux/slicers/requestSlicer';
import { apiErrorHandler } from '../../../helpers/axiosHelper';
import SelectCategory from '../../../components/Request/SelectCategory';
import Upload3DExistingFile from './Upload3DExistingFile';
import Select3DModel from './Select3DModel';
import SubmitPopUp from '../../../components/Request/SubmitPopUp';
import PartsZoom from './PartsZoom';
import { apiGetRequestImages, apiUploadRequestFiles } from '../../../helpers/api';
import { errorToast } from '../../../helpers/toastHelper';
import {
  REQUEST_EDIT_MAIN_ROUTE,
  REQUEST_EDIT_ROUTE,
  REQUESTS_ROUTE,
  REQUESTS_ROUTE_MODELS,
  REQUESTS_ROUTE_PDP,
} from '../../../constants/routePathConstants';

const REQUEST_PAGE_COMPONENT = [
  { id: 1, component: <Name /> },
  { id: 2, component: <Type /> },
  { id: 3, component: <Images /> },
  { id: 4, component: <Size /> },
  { id: 5, component: <Parts /> },
  { id: 6, component: <Finishes /> },
  { id: 7, component: <Notes /> },
];

const REQUEST_SUB_PAGE_COMPONENT = [
  { id: 1, component: <SelectCategory /> },
  { id: 2, component: <Upload3DExistingFile /> },
  { id: 3, component: <Select3DModel /> },
  { id: 4, component: <SubmitPopUp /> },
  { id: 5, component: <PartsZoom /> },
];

const SIZE_LIMIT = 1610612736; // 1.5GB

export const getRequestPageComponent = (_id) =>
  REQUEST_PAGE_COMPONENT.find((item) => item.id === _id)?.component;

export const getRequestSubPageComponent = (_id) =>
  REQUEST_SUB_PAGE_COMPONENT.find((item) => item.id === _id)?.component;

export const getCurrentRequestSubPage = (currentPage, _id) =>
  currentPage?.data?.subPages?.find((item) => item.id === _id);

export const getNextPageId = (current_page, _requestSelector) => {
  // if (!_requestSelector?.hasCustomizableparts && current_page.goNextTo === 6) return 7;
  return current_page.goNextTo;
};

export const getPreviousPageId = (current_page, _requestSelector) => {
  // if (!_requestSelector?.hasCustomizableparts && current_page.goBackTo === 6) return 5;
  return current_page.goBackTo;
};

export const getPreviousPage = (currentPage, _requestSelector) =>
  _requestSelector.requestPages.find((_item) => _item.id === currentPage.goBackTo);

export const updateRequestPage = (currentPage, dispatch, data, _requestSelector) => {
  const _data = data?.data || currentPage.data;

  // console.log(_data.parts);

  // if (!_requestSelector?.hasCustomizableparts && _data?.parts?.length) {
  //   currentPage?.data?.parts?.forEach(
  //     async (_item) => await apiDeleteRequestPart(_item?.actual_id)
  //   );
  //   data.data = { images: [], parts: [] };
  // }

  const goToNextPage = async (nextIsSubpage = false) => {
    let _data;

    if (nextIsSubpage) {
      _data = { ...currentPage, ...data };
    } else {
      let goToPageId = getNextPageId(currentPage, _requestSelector);

      if (goToPageId) dispatch(setCurrentRequestPageId(goToPageId));
      dispatch(setCurrentRequestSubPageId(null));

      _data = { ...currentPage, ...data, isCompleted: true };
    }

    if (data?.data) {
      dispatch(updateRequestPages(_data));
    }
  };

  if (_data?.subPages?.length) {
    let goToPageId;
    if (!_requestSelector.currentRequestSubPageId) {
      goToPageId = _data?.subPages[0].id;
    } else {
      goToPageId = getCurrentRequestSubPage(
        currentPage,
        _requestSelector.currentRequestSubPageId
      ).goNextTo;
    }

    if (goToPageId) {
      dispatch(setCurrentRequestSubPageId(goToPageId));
      goToNextPage(true);
    } else goToNextPage();
  } else goToNextPage();
};

export const checkFileTypes = (files, allowedTypes, errorMsg) => {
  if (
    files.some((file) => {
      const ext = file.name.split('.').pop()?.toLowerCase(); // Extract and normalize extension
      return !(allowedTypes.includes(file?.type) || allowedTypes.includes(`.${ext}`)); // Check either file type or extension
    })
  ) {
    apiErrorHandler({ message: errorMsg });
    return false;
  }
  return true;
};

export const getFileSize = (fileSize) => {
  let sizes = ['KB', 'MB', 'GB'];
  let size = fileSize / 1024;
  let i = 0;

  while (true) {
    if (size < 1000) break;
    size = size / 1000;
    i++;
  }

  return `${size.toFixed(1)} ${sizes[i]}`;
};

export const checkIsHexColor = (_code) => /^#[0-9A-F]{6}$/i.test(_code);

export const uploadRequestFile = async (
  formData,
  _files,
  files,
  setFiles,
  apiFunc,
  isComment,
  dispatch,
  _requestSelector
) => {
  if (!apiFunc) apiFunc = apiUploadRequestFiles;

  //  Validation for size limit

  let _fileSize = 0;

  _files.forEach((a) => (_fileSize = _fileSize + a.size));

  if (_requestSelector.currentRequestFilesSize + _fileSize > SIZE_LIMIT) {
    errorToast("Can't upload selected files as it exceeds 1.5 GB size limit.");
    return;
  }

  dispatch(setCurrentRequestFilesSize(_requestSelector.currentRequestFilesSize + _fileSize));

  // Upload files if size limit is not exceeded

  return await apiFunc(formData).then(async (res) => {
    const _data = !isComment ? res?.data : res?.data?.images;

    const updatedData = _files.map((a) => {
      const { id, presigned_data_file, presigned_url_file, presigned_data_thumbnail, presigned_url_thumbnail } = _data.find(
        (b) => b.presigned_data_file.fields.key.split('/').at(-1) === a.name
      );

      return {
        file: a,
        url: URL.createObjectURL(a),
        image: URL.createObjectURL(a),
        id: id,
        is_uploaded: false,
        version: 1,
        presigned_data_file,
        presigned_url_file,
        presigned_data_thumbnail,
        presigned_url_thumbnail,
      };
    });

    if (setFiles) setFiles([...files, ...updatedData]);

    if (isComment) return { data: { ...res.data, images: updatedData }, status: true };

    return updatedData;
  });
};

export const getFileFormData = (_files, _id, _fileType) => {
  const formData = new FormData();
  formData.append('file_type', _fileType);
  formData.append('three_d_model_request', _id);
  _files.forEach((item) => {
    formData.append('file_name', item.name);
    formData.append('file_size', item.size);
  });

  return formData;
};

export const checkIfImage = (url) => {
  if (!url || !Object.keys(url).length) return;
  return (
    url
      ?.split('?')[0]
      ?.toLowerCase()
      ?.match(/\.(jpeg|jpg|gif|png|avif|webp)$/) != null
  );
};

export const getNameFromUrl = (url) => {
  if (!url) return;
  const name = url.split('?')[0].split('/').at(-1);
  return name;
};

export const getFormattedTime = (_time) => {
  const _date = new Date(_time);
  const _month = _date.toLocaleString('default', { month: 'long' });
  const _local_time = _date.toLocaleString('default', { timeStyle: 'short' });

  return `${_month} ${_date.getDate()} at ${_local_time}`;
};

export const getNameInitials = (_data) => {
  const first_name_initial = _data?.first_name?.charAt(0) || _data?.email?.charAt(0);
  const last_name_initial = _data?.last_name?.charAt(0) || '';

  return `${first_name_initial.toUpperCase()}${last_name_initial.toUpperCase()}`;
};

export const setFilesObject = (_item) => {
  return {
    ..._item,
    ...{
      file: { name: _item.filename, size: _item.file_size, isComplete: true },
      url: _item.file,
    },
  };
};

export const setDefaultFiles = async (
  _id,
  type,
  setFiles,
  returnAsObject = false,
  params = '',
  setLoading
) => {
  if (setLoading) setLoading(true);
  const _files = await apiGetRequestImages(
    `three_d_model_request=${_id}&file_type=${type}&sort=id&${params}&per_page=100`
  );

  if (setLoading) setLoading(false);

  if (!setFiles) return _files;

  if (_files?.results?.length) {
    const _tempFiles = _files.results.map((_item) => {
      const _all_files = setFilesObject(_item);
      if (_item.view_type) return { [_item.view_type]: _all_files };
      else return _all_files;
    });

    if (returnAsObject) {
      const finalObject = {};

      _tempFiles.forEach((_item) => (finalObject[Object.keys(_item)] = Object.values(_item)[0]));
      setFiles(finalObject);
      return finalObject;
    } else {
      setFiles(_tempFiles);
      return _tempFiles;
    }
  }
};

// Will fix this in V2. Right now no time

const initialRequestState = {
  isNextButtonEnabled: false,
  requestPages: [
    { id: 1, name: 'Name', goNextTo: 2, goBackTo: null },
    {
      id: 2,
      name: 'Type',
      goNextTo: 3,
      goBackTo: 1,
    },
    { id: 3, name: 'Images', showSkipButton: true, goNextTo: 4, goBackTo: 2 },
    { id: 4, name: 'Size', showSkipButton: true, goNextTo: 5, goBackTo: 3 },
    { id: 5, name: 'Parts', showSkipButton: true, goNextTo: 6, goBackTo: 4 },
    { id: 6, name: 'Finishes', showSkipButton: true, goNextTo: 7, goBackTo: 5 },
    { id: 7, name: 'Notes', goNextTo: null, goBackTo: 6 },
  ],
  currentRequestPageId: 1,
  currentRequestSubPageId: null,
  currentRequestId: null,
  submitButtonTitle: 'Next',
  currentPage: { id: 1, name: 'Name', goNextTo: 2, goBackTo: null },
  hideSideBar: false,
  requestName: '',
  requestData: '',
};

export const getInitialRequestData = () => ({ ...initialRequestState });

export const isValidUrl = (urlString) => {
  // var urlPattern = new RegExp(
  //   '^(https?:\\/\\/)?' + // validate protocol
  //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
  //     '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
  //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
  //     '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
  //     '(\\#[-a-z\\d_]*)?$',
  //   'i'
  // ); // validate fragment locator
  // return !!urlPattern.test(urlString);

  return !!urlString;
};

export const isValidUrlV2 = (urlString) => {
  var urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const showRequestTabs = () => {
  const allowedRoutes = [REQUESTS_ROUTE, REQUESTS_ROUTE_MODELS, REQUESTS_ROUTE_PDP];
  return allowedRoutes.includes(window.location.pathname);
};

export const isLocalhost = () => {
  return window.location.hostname === 'localhost';
};
